/**
 * 图层类(窗口类)
 */
import { v4 as uuidv4 } from "uuid";
export default class Window {
  constructor(window = {}) {
    this.uuid = uuidv4(); //唯一key值
    this.windowId = window.windowId || 0; //窗口编号
    this.windowName = window.windowName || ""; //窗口名称
    this.windowMode = window.windowMode || ""; //窗口属性(文字、图片...)
    this.x = window.x || 0; //x坐标，窗距左
    this.y = window.y || 0; //x坐标，窗距顶
    this.z = window.z || 1; //窗口等级(窗口所在页面的层级)
    this.width = window.width || 100; //宽度
    this.height = window.height || 100; //高度
    this.className = window.className; //窗口样式名称
    this.style = window.style || {}; //样式对象
    this.defaultStyle = window.defaultStyle || {}; //样式对象
    this.windowType = window.windowType || "page"; //窗口类型
    this.hyperlinkType = window.hyperlinkType || "no"; //跳转方式
    this.hyperlinkPageId = window.hyperlinkPageId || -1; //页面跳转链接
    this.hyperlinkWndId = window.hyperlinkWndId || -1; //窗口跳转链接
    this.showState = window.showState || ""; //右侧栏默认素材还是属性
    this.minWidth = window.minWidth || 100;
    this.maxWidth = window.maxWidth || 1920;
    this.minHeight = window.minHeight || 400;
    this.maxHeight = window.maxHeight || 1920;
    this.defWidth = window.defWidth || 100;
    this.defHeight = window.defHeight || 100;
    this.defX = window.defX || 0; //x坐标，窗距左
    this.defY = window.defY || 0; //x坐标，窗距顶
    this.fullScreen = window.fullScreen || false; //窗口是否全屏
    //窗口特殊属性
    this.templateId = window.templateId || -1;
    this.materialList = window.materialList || []; //窗口关联的素材列表
    this.animatedName = window.animatedName || ""; //动画样式名称
    this.characterContent = window.characterContent || ""; //文字内容
    this.fontSize = window.fontSize || 50; //字体大小(需要等比例显示转换)
    this.fontColor = window.fontColor || "#000000"; //字体颜色
    this.backgroundColor = window.backgroundColor || "#FFFFFF"; //背景颜色
    this.backTransparent = window.backTransparent || 0; //透明度，终端是0是全透明（web0是不透明）
    this.showBackgroundColor = "rgba(255, 255, 255, 0)"; //跟上面的默认背景色保持一致
    this.characterStyle = window.characterStyle || "normal"; //字体类型
    this.alignType = window.alignType || "left"; // 水平对齐方式 || 表格对齐
    this.verticaAlignType = window.verticaAlignType || "top"; //垂直对齐方式
    this.enabledAudio = window.enabledAudio || false; //关掉音频
    this.backgroundPic = window.backgroundPic || ""; //背景图片
    this.backgroundPicName = window.backgroundPicName; //背景图片名称
    this.backgroundPicDeleteFlag = window.backgroundPicDeleteFlag || false; //背景图片删除标识 true 已删除
    this.backgroundType = window.backgroundType; //背景图片类型,用于判断背景图片是否用url的背景图
    this.cancelType = window.cancelType || "auto"; //取消类型(抓图)
    this.duration = window.duration || 10; //显示时间(抓图)
    const date = new Date();
    date.setTime(date.getTime() + 24 * 3600 * 1000);
    this.endTime = window.endTime || date; //终止时间(倒计时，默认为后一天)
    this.template = window.template || "template1"; //倒计时模板种类
    this.timeUnit = window.timeUnit || "day"; //倒计时单位
    this.timeUnitEnabled = window.timeUnitEnabled || false; //倒计时单位是否生效
    this.maxTimeUnit = window.maxTimeUnit || "year"; //倒计时最大时间单位
    this.TimeFontCfg = window.TimeFontCfg || "year"; //倒计时兼容以前实现数据记录
    this.subWindows = window.subWindows || []; //子窗口列表
    this.subwindowGroups = window.subwindowGroups || []; // 倒计时模板多个子窗口成对配置，需要单独处理，如果后面是和其他模板一样单个子窗口配置参数，可以去掉。
    this.fontBorderStyle = window.fontBorderStyle || {}; // 1.5新增文字边框配置
    this.rollingDirection =
      window.rollingDirection === undefined ? "" : window.rollingDirection; // 1.5新增文字滚动方向 2.0交互上写着从右到左 led交互默认无
    this.scrollLine = window.scrollLine || 1; // 上下滚动的行数
    this.singeCharacterHeigh = window.singeCharacterHeigh || 30;
    this.scrollSpeed = window.scrollSpeed || 5; // 2.0 新增文字滚动速度
    //叫号窗口
    this.tableType = window.tableType; //表格样式
    this.tableRow = window.tableRow; //表格行数
    this.tableColumn = window.tableColumn; //表格列数
    this.tableDirection = window.tableDirection; //表格方向 横、竖
    //this.alignType = window.alignType; //表格对齐
    this.refreshDirection = window.refreshDirection; //表格刷新方向
    this.tableHeaders = window.tableHeaders || []; //表格信息集合
    //客流测温相关属性
    this.maxPeopleNumber = window.maxPeopleNumber; //最大可进入人数
    this.abnormalHighTemperature = window.abnormalHighTemperature || 37.5; //异常高温值
    this.maskAlarm = window.maskAlarm || {
      //未佩戴口罩语音报警
      enabled: false,
      materialNo: -1,
      materialName: "",
    };
    this.temperatureAlarm = window.temperatureAlarm || {
      //体温异常语音报警
      enabled: false,
      materialNo: -1,
      materialName: "",
    };
    this.unavailableAlarm = window.unavailableAlarm || {
      //客流已满语音报警
      enabled: false,
      materialNo: -1,
      materialName: "",
    };
    //考勤
    this.mainTitleWindow = window.mainTitleWindow || {}; //主标题窗口
    this.subTitleWindow = window.subTitleWindow || {}; //副标题子窗口
    this.signinLibs = window.signinLibs || []; //在库人员信息
    this.signoutLibs = window.signoutLibs || []; //未知人员信息
    this.outLibName = window.outLibName || ""; //未知人员姓名
    this.showDuration = window.showDuration || "always"; //签到记录显示
    this.backgroundIPC = window.backgroundIPC || ""; //相机背景图
    this.playType = window.playType || ""; //视频窗口类型
    this.notShowEdit = false; //多选时，点击去全选，不能操作当前编辑的素材
    this.windowApplication = 0; //保存考勤模板id

    //三方数据
    this.tripartiteType = window.tripartiteType || "push"; //三方数据源方式
    this.sourceId = window.sourceId || -1; //三方数据源id
    this.dataType = window.dataType || "table"; //三方数据的类别 数据视图、图表、图片、文字
    this.sourceTemplate = window.sourceTemplate || 1; //图表的模板id
    this.sourceRow = window.sourceRow || 1; //表格行数
    this.sourceColumn = window.sourceColumn || 1; //表格列数
    this.sourcePlayMode = window.sourcePlayMode || "roll"; //数据播放方式
    this.sourceTableDirection = window.sourceTableDirection; //表格方向 横、竖
    this.sourceTables = window.sourceTables; //表格信息集合 [{index, lineIndex: "",name: "", fontSize: "", fontColor: "", background: "", emptyRate: "", alignType: "", verticaAlignType: ""}]
    this.sourceEditIndex = -1;
    // 微动效参数 实际上是素材的属性 但是平台上只能在窗口那层支持配置
    this.AnimationEffectList = window.AnimationEffectList || [];

    // 2.1 新增
    this.borderRadius = window.borderRadius || 0; // 圆角 范围 0-45
    this.rotate = window.rotate || 0; // 旋转 范围 0-360
    this.fontFamily = window.fontFamily || -1; // 字体
    this.rssUrl = window.rssUrl || ""; //  rssURL
    this.weatherShowType = window.weatherShowType || ""; // 天气类型
    this.dateShowType = window.dateShowType || 4; //日期时间格式
    this.updateInterval = window.updateInterval || 60; // 刷新间隔
    this.rssPageTime = window.rssPageTime || 10; // rss翻页时间

    // 窗口属性也太多了 后续属性用工厂方法
    switch (this.windowMode) {
      case "character":
        this.initCharacterData(window);
        break;
      case "dataSource":
        if (this.dataType === "character") {
          this.initCharacterData(window);
        }
        break;
      case "weather":
        this.initWeatherData(window);
        break;
      case "signalSource":
        this.initSignalSourceData(window);
        break;
      default:
        break;
    }
  }

  initCharacterData(window) {
    // 是否启用文字删除线
    this.strikethroughEnabled = window.strikethroughEnabled || false;
    // 文字边框参数
    this.fontBorder = window.fontBorder || {};
    // 字体渐变参数
    this.fontGradient = window.fontGradient || {};
    // 字体阴影参数
    this.fontShadow = window.fontShadow || {};
    this.showTextColor = window.fontColor; //后续用于展示处理字体颜色
  }

  initWeatherData(window) {
    this.lockAspectRatio = window.lockAspectRatio || false;
    this.aspectFactor = window.aspectFactor || 1;
    this.firstSelected = window.firstSelected || true;
  }

  initSignalSourceData(window) {
    this.signalSourceType = window.signalSourceType || "";
    this.signalSourceSubTypeId = window.signalSourceSubTypeId || "";
    this.signalSourceName = window.signalSourceName || "";
  }
}
